import { tokenManager } from "lib/tokenManager";
import { API_BASE } from "../config";

/**
 * PRTL-1350: download a set of attachments as one zip.
 *
 * Calls the server's `POST /files/zip` (JWT-authed; every file is checked
 * against the caller's visibility scope), receives the archive as a blob, and
 * saves it through a same-origin object URL. One user gesture → one file, so
 * popup blockers never get involved (unlike opening N presigned URLs).
 */
export async function downloadFilesAsZip(fileIds: string[], archiveName = "attachments") {
    const token = tokenManager.get();
    const res = await fetch(`${API_BASE}/files/zip`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ fileIds, archiveName }),
    });
    if (!res.ok) {
        let message = "Couldn't download attachments.";
        try {
            const body = (await res.json()) as { error?: string };
            if (body.error) message = body.error;
        } catch {
            // non-JSON error body — keep the generic message
        }
        throw new Error(message);
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    try {
        const a = document.createElement("a");
        a.href = url;
        a.download = `${archiveName}.zip`;
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
    } finally {
        // Give the browser a tick to start the download before revoking.
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
}
